
export class UploadSignBase64Request
{
	public Algorithm: string;
	public Signature: string;
	public PluginVersion: string;
	public CSPVersion: string;
	public CSPName: string;

	constructor(algorithm: string, signature: string, pluginVersion: string, cSPVersion: string, cSPName: string)
	{
		this.Algorithm = algorithm;
		this.Signature = signature;
		this.PluginVersion = pluginVersion;
		this.CSPVersion = cSPVersion;
		this.CSPName = cSPName;
	}

}
